import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const handleDownload = async (elementRef) => {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  var clone = elementRef.current;
  var element = clone.cloneNode(true);
  document.body.appendChild(element);

  if (!element) {
    console.error("Element reference is not defined.");
    return;
  }

  const originalWidth = element.style.width;

  try {
    element.style.width = "1080px";
    const canvas = await html2canvas(element, { scale: 2 });
    const imgData = canvas.toDataURL("image/jpg");
    const pdf = new jsPDF("p", "mm", "a4", true);

    const padding = 5;
    const pdfWidth = 190;
    const topMargin = 20;
    const pdfHeight = 280;
    const imgWidth = pdfWidth - 2 * padding;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = padding;

    const watermarkImg = new Image();
    watermarkImg.src = `/logo512.png`;

    await new Promise((resolve, reject) => {
      watermarkImg.onload = resolve;
      watermarkImg.onerror = (err) => {
        console.error("Watermark image failed to load:", err);
        reject(err);
      };
    });

    const createWatermarkCanvas = (opacity) => {
      const watermarkCanvas = document.createElement("canvas");
      const watermarkCtx = watermarkCanvas.getContext("2d");

      const watermarkWidth = pdfWidth * 0.8;
      const watermarkHeight = pdfWidth * 0.8;

      watermarkCanvas.width = pdfWidth;
      watermarkCanvas.height = pdfHeight;

      watermarkCtx.globalAlpha = opacity; // Set watermark opacity
      watermarkCtx.drawImage(
        watermarkImg,
        0,
        0,
        watermarkWidth,
        watermarkHeight
      );

      return watermarkCanvas.toDataURL("image/png");
    };

    const firstPageWatermark = createWatermarkCanvas(0.1); // 10% opacity for the first page
    const subsequentPageWatermark = createWatermarkCanvas(0.1); // 10% opacity for subsequent pages

    const watermarkX = (pdfWidth - pdfWidth * 0.8 + 25) / 2;
    const watermarkY =
      (pdfHeight -
        (pdfWidth * 0.8) / (watermarkImg.width / watermarkImg.height) +
        50) /
      2;

    const currentDate = new Date().toLocaleDateString();
    const logo = new Image();
    logo.src = `/logo512.png`;

    pdf.addImage(
      logo,
      "PNG",
      5,
      5,
      110 * 0.264583,
      110 * 0.264583,
      undefined,
      "FAST"
    );
    pdf.setFontSize(12);
    pdf.text(currentDate, pdfWidth - 30, 20); // Adjust position for date

    pdf.addImage(
      imgData,
      "PNG",
      padding,
      30,
      imgWidth,
      imgHeight,
      undefined,
      "FAST"
    ); // Adjust for header height
    heightLeft -= pdfHeight - 2 * padding - 30;

    while (heightLeft >= 0) {
      position = heightLeft - imgHeight + padding;
      pdf.addPage();
      pdf.addImage(
        imgData,
        "PNG",
        padding,
        position,
        imgWidth,
        imgHeight,
        undefined,
        "FAST"
      );

      heightLeft -= pdfHeight - 2 * padding;
    }

    // Create a Blob URL for the PDF
    const pdfBlob = pdf.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Open in new tab or directly download for Safari
    if (isSafari) {
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = "download.pdf";
      link.click();
    } else {
      window.open(pdfUrl, "_blank");
    }
  } catch (error) {
    console.error("Failed to generate PDF:", error);
  } finally {
    document.body.removeChild(element);
  }
};

const Achievement1 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/1.svg";
const Achievement2 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/2.svg";
const Achievement3 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/3.svg";
const Achievement4 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/4.svg";
const Achievement5 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/5.svg";
const Achievement6 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/6.svg";
const Achievement7 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/7.svg";
const Achievement8 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/8.svg";
const Achievement9 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/9.svg";
const Achievement10 =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/10.svg";
const getAchievementSrc = (score) => {
  if (score < 50) return null; // No badge for score < 50
  if (score >= 2500) return Achievement10; // Beacon Of Medicine
  if (score >= 2000) return Achievement9; // Luminary
  if (score >= 1750) return Achievement8; // Wizard
  if (score >= 1500) return Achievement7; // Hero
  if (score >= 1250) return Achievement6; // Disease Conqueror
  if (score >= 1000) return Achievement5; // Master Blaster
  if (score >= 500) return Achievement4; // Scholar
  if (score >= 250) return Achievement3; // MedExpert
  if (score >= 100) return Achievement2; // Apprentice
  return Achievement1; // Novice (for score >= 50)
};

const GetBadgeName = (score) => {
  if (score < 50) return null; // No badge for score < 50
  if (score >= 2500) return "Beacon Of Medicine";
  if (score >= 2000) return "Luminary";
  if (score >= 1750) return "Wizard";
  if (score >= 1500) return "Hero";
  if (score >= 1250) return "Disease Conqueror";
  if (score >= 1000) return "Master Blaster";
  if (score >= 500) return "Scholar";
  if (score >= 250) return "MedExpert";
  if (score >= 100) return "Apprentice";
  return "Novice"; // Default for score >= 50
};

export default handleDownload;
export { getAchievementSrc, GetBadgeName };
